<template>
<div>

  <div class="text-center m-10" v-if="schema.fields.length <=0">
    未配置显示组件
  </div>
  <div class="m-b-10" v-else-if="schema.isShowMode=='list' && config.formDataList[pluginIndex] && config.formDataList[pluginIndex].length >0">
    <div class="block-title" v-if="schema.label !=''">
      {{schema.label}}
    </div>
    <van-steps direction="vertical" :active="0" active-icon="arrow-up">
      <!-- 数据列表 -->
      <van-step  v-for="(dbRow,dbIndex) in config.formDataList[pluginIndex]" :key="dbIndex">
        <!-- 要显示组件 -->
          <div v-for="(showItem, showIdx) in schema.fields" :key="showIdx">
            <!-- 找出组件数据 -->
            <div v-for="(dbItem, dbIdx) in dbRow.data_json" :key="dbIdx" >
              <!-- 找到名字uniqid相同的 -->
              <div v-if="dbItem.uniqid == showItem.uniqid && dbItem.name == showItem.name">
                  <div v-if="dbItem.name =='imgUploader' && dbItem.value && dbItem.value !=''">
                    <div class="form-data_li">{{dbItem.label}}：</div>
                    <van-uploader v-model="dbItem.value" :show-upload="false" :deletable="false" :lazy-load="true" />
                </div>
                <div class="form-data_li" v-else-if="dbItem.name =='location' && dbItem.value!=''" @click="onViewLocation(dbItem)">
                  {{dbItem.label}}：<van-icon name="location" /> {{dbItem.value.district}}{{dbItem.value.addr}}
                </div>
                <div class="form-data_li" v-else-if="dbItem.name =='mapMarked' && dbItem.value!=''"  @click="onViewLocation(dbItem)">
                  {{dbItem.label}}：<van-icon name="map-marked" /> {{dbItem.value.poiname}}
                </div>
                <div class="form-data_li" v-else-if="dbItem.name =='switchOff'" >
                  {{dbItem.label}}：<van-icon name="success" color="#07c160" v-if="dbItem.value==1"/> <van-icon name="cross" color="#ee0a24" v-if="dbItem.value!=1"/>
                </div>
                <div class="form-data_li" v-else-if="dbItem.name =='rate'" >
                  {{dbItem.label}}：<van-rate v-model="dbItem.value" :icon="showItem.icon" :void-icon="showItem.icon + '-o'" :count="showItem.count" :allow-half="showItem.allowHalf" :void-color="showItem.voidColor" :color="showItem.color" readonly/>
                </div>
                <div class="form-data_li" v-else-if="dbItem.name =='tableField'" >
                  {{dbItem.label}}：
                  <div style="margin:5px 10px;">
                    <div class="van-table">
                      <div class="van-table__main van-table__main--striped">
                        <div class="van-table__main__body">
                          <div class="van-table__main__body__tr" v-for="(item, idx) in dbItem.value" :key="idx">
                            <span class="van-table__main__body__tr__td van-table__main__head__tr--border van-table__main__head__tr--align" >{{ item.label }}</span>
                            <span class="van-table__main__body__tr__td van-table__main__head__tr--border van-table__main__head__tr--align">
                              {{ item.value }}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-data_li" v-else-if="dbItem.name =='checkList'" >
                  {{dbItem.label}}：
                  <div style="margin:5px 10px;">
                    <div class="van-table">
                      <div class="van-table__main van-table__main--striped">
                        <div class="van-table__main__body">
                          <div class="van-table__main__body__tr" v-for="(item, idx) in dbItem.value" :key="idx">
                            <span class="van-table__main__body__tr__td van-table__main__head__tr--border van-table__main__head__tr--align" >{{ item.label }}</span>
                            <span class="van-table__main__body__tr__td van-table__main__head__tr--border van-table__main__head__tr--align">
                              <template v-if="item.status=='yes'"><van-icon name="passed" color="#07c160" size="16" /> 正常</template>
                              <template v-else-if="item.status=='no'"><van-icon name="close" color="#ee0a24" size="16" /> 异常</template>
                              <template v-else><van-icon name="more-o" color="#ff976a"/> 无状态</template>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-data_li" v-else-if="formDataFieldCheck(dbItem.name) && dbItem.value!=''">
                  {{dbItem.label}}：{{dbItem.value}}
                </div>
                
              </div><!-- end if -->
            </div><!-- end for fields -->
        </div><!-- end for formDataList -->
        <div v-if="schema.isShowTime">提交时间：{{dbRow.create_time}}</div>
      </van-step>
      
    </van-steps>
    <div class="block-title text-center" v-if="config.formDataList[pluginIndex].length>=3">
      <van-button type="info" size="small" icon="share" @click="onNavFormData()"  native-type="button">查看更多{{schema.label}}</van-button>
    </div>
  </div>
  <!-- && config.qrData.form_count >0 -->
  <div class="m-b-10" v-else-if="schema.isShowMode=='pwd'">
    <div class="block-title" v-if="schema.label !=''">
      {{schema.label}}
    </div>
    <div class="block-title text-center">
      <van-button type="info" size="small" icon="bars" @click="onNavFormData()"  native-type="button">查看{{schema.label}}</van-button>
    </div>
  </div>
    

  <van-popup v-model="viewMapLocation" @close="viewMapLocation = false" :style="{ height: '100%',width:'100%' }" close-icon="close" class="map-popup" closeable >
    <div style="width:100%;height:100%;" v-if="mapLocation.lat !=''">
    <iframe id="mapPage" style="width:100%;height:100%;" frameborder=0
        :src="'https://apis.map.qq.com/uri/v1/marker?marker=coord:'+ mapLocation.lat +','+mapLocation.lng +';title:'+ encodeURIComponent(mapLocation.title)+';addr:'+ encodeURIComponent(mapLocation.address)+'&referer=2weima.com'">
    </iframe>
    </div>
  </van-popup>

</div>
</template>

<script>
import { mapState } from 'vuex'
// import { Notify } from 'vant';
import utils from "../../../utils/utils"

export default {
  name: 'formData',
  props: {
    schema: {
      'type':Object,
      default:{},
      required:true
    },
    pluginIndex:{
      type:Number,
      default:0
    }
  },
  computed:{
    ...mapState(['config']),
  },
  data:function(){
    return {
      viewMapLocation:false,
      mapLocation:{
        lat:'',
        lng:'',
        title:'',
        address:''
      }
    }
  },
  methods:{
    formDataFieldCheck(pluginName){
      return utils.formDataFieldCheck(pluginName)
    },
    //跳转查看更多表单记录
    onNavFormData:function(){
      location.href = this.config.formDataUrl + '&plugin_name=' + this.schema.name + '&plugin_uniqid=' + this.schema.uniqid;
    },
    onViewLocation:function(fieldData){
 
      if(fieldData.name=='mapMarked'){
        this.mapLocation = {
          lat:fieldData.value.latlng.lat,
          lng:fieldData.value.latlng.lng,
          title:fieldData.value.poiname,
          address:fieldData.value.poiaddress
        };
      }else if(fieldData.name=='location'){
        this.mapLocation = {
          lat:fieldData.value.latitude ||　fieldData.value.lat, //h5= lat  weapp =latitude
          lng:fieldData.value.longitude|| fieldData.value.lng,
          title:fieldData.value.city,
          address:fieldData.value.addr
        };
      }

      // console.log('mapLocation',this.mapLocation)
      // return;

      this.viewMapLocation = true;

    },

    // onScan(){
    //   Notify({ type: 'warning', message: '点击了扫码',duration: 800 });
    // }
  }
}
</script>

<style>
.map-popup .van-popup__close-icon{
  color: red !important;
  font-size: 30px !important;
}
</style>